import {
    isStringSet,
    isEmptyObject,
    isDefined,
    isNotNullOrEmpty
} from 'utilities/is';

import { List } from 'immutable';
import { DateTime } from 'luxon';

export const expiryIds = {
    DOES_NOT_EXPIRE: 'FF40AEDB-2A07-4838-9FF0-10B725C41521',
    EXPIRE_AFTER_SET_PERIOD: 'F03E9423-92E6-467F-A61E-6FA591C1A779',
    SPECIFY_EXPIRY_DATE: 'C5C5052B-CD31-4B02-AFD6-FFF27D0C6DC9'
};

export const hasCompetencies = (competencies, filter) => filterCompetencies(competencies || [], filter).length > 0;

export const suspensions = (competences) =>
    List(competences)
        .filter(c => c.hasOwnProperty('suspension'))
        .map(c => c.suspension)
        .sortBy(s => s.divisionName)
        .toArray();

export const competencies = (competenceData) =>
    List(competenceData)
        .filter(c => c.hasOwnProperty('competence'))
        .map(c => c.competence)
        .sortBy(c => c.name)
        .toArray();

export const restrictions = (competenceData) =>
    List(competenceData)
        .filter(c => c.hasOwnProperty('restriction'))
        .map(c => c.restriction)
        .sortBy(r => r.name)
        .toArray();

export const breathalyserTestsForSite = (competenceData, siteID) =>
                 List(competenceData)
            .filter(c => c.hasOwnProperty('breathalyserTest'))
            .map(c => c.breathalyserTest)
            .filter(s=> String(s.siteID) === String(siteID))
            .sortBy(r => r.testDate)
            .toArray();
       
export function filterCompetencies(competencies, filter, inverseFilter) {

    const nationalPredicate = comps => comps.filter(comp =>
        !isStringSet(comp.companyID) &&
        !isStringSet(comp.divisionID) &&
        !isStringSet(comp.employerID) &&
        !isStringSet(comp.projectID) &&
        !isStringSet(comp.siteName) &&
        !isStringSet(comp.zoneName));

    const inverted = inverseFilter ? comps => comps.filter(comp => !isStringSet(comp[inverseFilter])) : comps => comps.filter(c => c);

    const attributePredicate = comps => comps.filter(comp => isStringSet(comp[filter]));

    return filter === "national"
        ? nationalPredicate(competencies)
        : inverted(attributePredicate(competencies, filter));
}

export function groupCompetencies(competencies, filter, inverseFilter) {

    const grouped = new Map();

    filterCompetencies(competencies, filter, inverseFilter).forEach(comp => {
        let group = grouped.get(comp.group);
        if (!group) {
            group = [];
            grouped.set(comp.group, group);
        }

        group.push(comp);
    });

    return grouped;
}

export function competenceTitle(c, filter, displayProp) {
    let name = c.name;

    if (filter !== "national" && c.hasOwnProperty(displayProp)) {
        name += ` (${c[displayProp]})`
    }
    return name;
}

export function zoneTitle(c, filter) {
    let name = c.name;

    if (filter !== "national" && c.hasOwnProperty('zoneName')) {
        name += ` (${c.siteName} - ${c.zoneName})`
    }
    return name;
}

export function groupCompetenciesByOrGroup(competences) {
    let grouped = {};

    for (const comp of competences) {
        const orGroup = comp.orGroup;
        if (isStringSet(orGroup)) {
            const group = grouped.hasOwnProperty(orGroup) ? grouped[orGroup] : [];
            group.push(comp);
            grouped[orGroup] = group;    
        } else {
            const ungrouped = grouped["__ungrouped__"] || [];
            ungrouped.push(comp);
            grouped["__ungrouped__"] = ungrouped;    
        }        
    }

    return grouped;
}

export function scheduledCompetencies(supervisorData, currentLocation) {
    if (!currentLocation || isEmptyObject(currentLocation) || !isDefined(currentLocation.site)) {
        return [];
    }

    if (!supervisorData || !isNotNullOrEmpty(supervisorData.scheduledComps)) {
        return [];
    }

    const mapper = sc => {
        return {
            ...sc,
            dueDate: DateTime.fromFormat(sc.dueDate, "dd/MM/yyyy")
        }
    };

    const now = DateTime.local();
    const today = DateTime.local(now.year, now.month, now.day, 0, 0, 0);

    const dateIsInScope = dueDate => {
        const diff = dueDate.diff(today);
        const diffInHours = diff.as("hours");
        const isAfterNow = diffInHours > -1;

        return isAfterNow;
    }

    return List(supervisorData.scheduledComps)
        .map(mapper)
        .filter(sc => sc.siteID === currentLocation.site.siteID && dateIsInScope(sc.dueDate))
        .sortBy(sc => sc.siteName)
        .toArray();
}
